import React from 'react';

import {Container} from 'react-bootstrap';

function Home() {

    return (
        <>
        <Container>
        <h1 className='text-center'>Home</h1>
        <p>A bare bones 3 page website template with navigation and basic styling via Bootstrap, just add your own content.</p>
        </Container>
        </>
    );
};

export default Home;